// extracted by mini-css-extract-plugin
export default {"logoContainer":"Logo_logoContainer__3VlH6","footText":"Logo_footText__+CmF7"};